import routerHelper from '$$routerHelper';
import constants from '$$helpers/constants';
import rights from '../../../../components/rights';

/**
 * Specifies the CSS class that will be applied to task bars
 * @param instance
 * @returns {function(*, *, *)}
 */
export default instance => (start, end, task) => {
  const isWorkload = routerHelper.isWorkloadViewRoute();
  const resClassFunc = (start, end, task) => {
    const isMultiview = instance.config.multiview;
    const addProjectTaskLevel = isMultiview ? 2 : 1;

    if (isMultiview) {
      if (task.parent === 1 && task.type === instance.config.types.project) {
        if (!task.color) {
          task.color = constants.DEFAULT_TYPE_COLORS.ESTIMATION;
        }

        return 'task_level_project';
      }
    }

    if (!task.parent && task.type === instance.config.types.project && instance.calculateTaskLevel(task.id) === 0) {
      if (!task.color) {
        task.color = constants.DEFAULT_TYPE_COLORS.ESTIMATION;
        // instance.updateTask(task.id, task);
      }

      return 'project_estimateTotal';
    }

    if (task.$virtual && task.type === instance.config.types.project) {
      return 'top_level_project task_grouping';
    }

    if (task.type === instance.config.types.project && instance.calculateTaskLevel(task.id) === addProjectTaskLevel) {
      if (!task.color) {
        task.color = constants.DEFAULT_TYPE_COLORS.PROJECT;
      }

      return 'top_level_project';
    }

    if (task.type === instance.config.types.button) {
      return 'gantt_btn_hide';
    }

    const taskNode = instance.getTaskNode(task.id);

    if (taskNode && parseInt(taskNode.style.width, 10) < 40) {
      if (instance.hasChild(task.id)) {
        return 'gantt_progress_drag_hide task_level_project';
      }

      return 'gantt_progress_drag_hide';
    }

    if (instance.isSelectedTask(task.id)) {
      return 'gantt_selected';
    }

    if (instance.hasChild(task.id)) {
      if (!task.color) {
        task.color = constants.DEFAULT_TYPE_COLORS.GROUP;
      }

      return 'task_level_project';
    }

    if (!task.color && task.type === instance.config.types.milestone) {
      task.color = constants.DEFAULT_TYPE_COLORS.MILESTONE;
    }

    if (!task.color && task.type === instance.config.types.task && !instance.hasChild(task.id)) {
      task.color = constants.DEFAULT_TYPE_COLORS.TASK;
    }

    return '';
  };

  let resClass = resClassFunc(start, end, task);

  if (task.color) {
    const colorValue = task.color;

    if (instance.config.discoloration_tasks && +task.status === 4 && task.type !== 'project' && !isWorkload) {
      resClass += ` task_discolor discoloration-tasks-${colorValue}`;
    } else {
      resClass += ` task-box-shadow-${colorValue}`;
    }
  }

  let rightsClass = '';
  const canResizeTask = rights.project.hasRight(task.gantt_id, 'static_fields');
  const canChangeProgressTask = rights.project.hasRightSomeOne(task.gantt_id, ['static_fields', 'static_fields_4_only']);
  const canCreateLinkTask = rights.project.hasRight(task.gantt_id, 'task_links');

  if (!canResizeTask) {
    rightsClass += ' gantt_resize_hide';
  }
  if (!canChangeProgressTask) {
    rightsClass += ' gantt_progress_drag_hide';
  }
  if (!canCreateLinkTask) {
    rightsClass += ' gantt_link_controls_hide';
  }

  return resClass + rightsClass;
};
